<template>
  <div id="app">
    <div class="top-card">
      <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++ Step 1 +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
      <div id="step1" class="card">
        <div class="card-title" style="background-color: #00247c">
          <h1>STEP 1</h1>
        </div>
        <div id="step1-content">
          <div class="rounded-img">
            <svg
              id="step1-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 108.77 151.31"
            >
              <g id="Layer_2" data-name="Layer 2">
                <g id="Overlay">
                  <path
                    class="stp1-1"
                    d="M89.79,17.5H86.94a1.41,1.41,0,0,0-1.41,1.42v5.34a1.4,1.4,0,0,0,1.38,1.42h2.88a10.78,10.78,0,0,1,10.79,10.78v95.88a10.79,10.79,0,0,1-10.77,10.8H19a10.79,10.79,0,0,1-10.8-10.77V36.48a10.77,10.77,0,0,1,10.76-10.8h2.88a1.41,1.41,0,0,0,1.42-1.39V18.92a1.41,1.41,0,0,0-1.42-1.42H19a19,19,0,0,0-19,19H0v95.86a19,19,0,0,0,19,19H89.79a19,19,0,0,0,19-19V36.48a19,19,0,0,0-19-19Z"
                  />
                  <path
                    class="stp1-2"
                    d="M48.93,50.72a1,1,0,0,0-1,1h0V54a1,1,0,0,0,1,1h40a1,1,0,0,0,1-1V51.67a1,1,0,0,0-1-1h-40Z"
                  />
                  <path
                    class="stp1-2"
                    d="M48.93,58.53a1,1,0,0,0-1,.95h0v2.37a1,1,0,0,0,1,1h40a1,1,0,0,0,1-1V59.48a1,1,0,0,0-1-.95h-40Z"
                  />
                  <path
                    class="stp1-2"
                    d="M48.93,79.51a1,1,0,0,0-1,.95h0v2.37a1,1,0,0,0,1,1h40a1,1,0,0,0,1-1V80.46a1,1,0,0,0-1-.95h-40Z"
                  />
                  <path
                    class="stp1-2"
                    d="M48.93,87.49a1,1,0,0,0-1,1h0v2.37a1,1,0,0,0,1,1h40a1,1,0,0,0,1-1V88.44a1,1,0,0,0-1-1h-40Z"
                  />
                  <path
                    class="stp1-2"
                    d="M48.93,108.4a1,1,0,0,0-1,.95h0v2.38a1,1,0,0,0,1,1h40a1,1,0,0,0,1-.94h0v-2.35a1,1,0,0,0-1-.95h0Z"
                  />
                  <path
                    class="stp1-2"
                    d="M48.93,115.88a1,1,0,0,0-1,1h0v2.39a1,1,0,0,0,1,1h40a1,1,0,0,0,1-1h0v-2.35a1,1,0,0,0-1-1h0Z"
                  />
                  <path
                    class="stp1-2"
                    d="M75.69,9.9H65.26a10.93,10.93,0,0,0-21.76,0H33.07a2.59,2.59,0,0,0-2.6,2.58V26.34A2.58,2.58,0,0,0,33,29h42.7a2.58,2.58,0,0,0,2.61-2.57V12.51A2.59,2.59,0,0,0,75.73,9.9ZM50.39,7A5.63,5.63,0,0,1,59.92,9.9,4.28,4.28,0,0,1,60,11a5.65,5.65,0,1,1-11.29.11,5.24,5.24,0,0,1,.11-1.18A5.53,5.53,0,0,1,50.39,7Z"
                  />
                  <path
                    class="stp1-1"
                    d="M34.17,59.57v3.57h-12v-12H32.67l3.06-3.41h-17V66.56H37.58V55.79Z"
                  />
                  <polygon
                    class="stp1-2"
                    points="29.95 61.74 23.63 55.65 25.98 53.18 29.78 56.84 39.66 45.81 42.2 48.08 29.95 61.74"
                  />
                  <path
                    class="stp1-1"
                    d="M34.17,88.38V92h-12v-12h10.5l3-3.42h-17V95.35H37.58V84.58Z"
                  />
                  <polygon
                    class="stp1-2"
                    points="29.95 90.54 23.63 84.44 25.98 81.98 29.78 85.63 39.66 74.6 42.2 76.87 29.95 90.54"
                  />
                  <path
                    class="stp1-1"
                    d="M34.17,117.3v3.58h-12v-12H32.67l3.06-3.41h-17v18.86H37.58V113.51Z"
                  />
                  <polygon
                    class="stp1-2"
                    points="29.95 119.46 23.63 113.36 25.98 110.9 29.78 114.55 39.66 103.53 42.2 105.8 29.95 119.46"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div class="text-container">
            <h2>{{ steps[0].title }}</h2>
            <p v-for="(sub, index) in steps[0].subtitle" :key="index">
              {{ sub }}
            </p>
          </div>
        </div>
        <div class="button-container">
          <button v-on:click="openLink(steps[0].link)">
            {{ steps[0].buttonText }}
          </button>
        </div>
      </div>
      <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++ Step 2 +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
      <div id="step2" class="card">
        <div class="card-title" style="background-color: #00247c">
          <h1>STEP 2</h1>
        </div>
        <div id="step2-content">
          <div class="rounded-img">
            <svg
              id="step2-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 153.35 150"
            >
              <g id="Layer_2" data-name="Layer 2">
                <g id="Overlay">
                  <path
                    class="stp2-1"
                    d="M16.05,75.24a15,15,0,0,1,15.1-15.1,15.1,15.1,0,1,1,0,30.2A15,15,0,0,1,16.05,75.24Z"
                  />
                  <path
                    class="stp2-1"
                    d="M49.36,93.45a38.88,38.88,0,0,0-24,34.74v.24H1.92A1.85,1.85,0,0,1,0,126.76v-12A23.52,23.52,0,0,1,23.48,91.29a2,2,0,0,1,1.68,1l6,11.74,6-11.74C38.58,89.62,46.49,92.25,49.36,93.45Z"
                  />
                  <path
                    class="stp2-1"
                    d="M106.87,75.24A15,15,0,0,1,122,60.14a15.1,15.1,0,1,1,0,30.2A15,15,0,0,1,106.87,75.24Z"
                  />
                  <path
                    class="stp2-1"
                    d="M153.35,114.78v12a1.88,1.88,0,0,1-1.91,1.91H127.72c0-.24.47-23.48-22.29-34.26-.48-.24-1.2-.48-1.68-.72a21.73,21.73,0,0,1,10.31-2.4,2,2,0,0,1,1.67,1l6,11.74,6-11.74a1.59,1.59,0,0,1,1.67-1A23.63,23.63,0,0,1,153.35,114.78Z"
                  />
                  <path
                    class="stp2-1"
                    d="M124.36,148.32a1.71,1.71,0,0,1-1.92,1.68H30.91A1.85,1.85,0,0,1,29,148.32V128.43c.48-18.21,15.82-34.26,35.71-34.26a2.94,2.94,0,0,1,1.91,1l10.31,20.13,10.3-20.13a1.61,1.61,0,0,1,1.68-1h.24c19.65,0,35.22,16,35.46,34.5C124.36,129.15,124.36,130.35,124.36,148.32Z"
                  />
                  <path
                    class="stp2-1"
                    d="M53.91,68.29A22.77,22.77,0,1,1,76.68,91.05C64.22,90.81,53.91,80.75,53.91,68.29Z"
                  />
                  <path
                    class="stp2-2"
                    d="M147.12,0H96.33a5.93,5.93,0,0,0-6,6V30.43a5.92,5.92,0,0,0,6,6h5.51V47.2A1.77,1.77,0,0,0,105,48.4l12-12h30.43a5.92,5.92,0,0,0,6-6V5.75A6.26,6.26,0,0,0,147.12,0Zm-4.79,26.12H101.12a1.92,1.92,0,0,1,0-3.84h41.21a1.89,1.89,0,0,1,1.92,1.92C144,25.16,143.29,26.12,142.33,26.12Zm0-11.74H101.12a1.92,1.92,0,0,1,0-3.84h41.21a1.89,1.89,0,0,1,1.92,1.92C144,13.66,143.29,14.38,142.33,14.38Z"
                  />
                  <path
                    class="stp2-2"
                    d="M49.36,17H5.27A5.32,5.32,0,0,0,0,22.28V43.37a5.32,5.32,0,0,0,5.27,5.27H31.39L41.69,59a1.83,1.83,0,0,0,3.12-1.2V48.64h4.55a5.31,5.31,0,0,0,5.27-5.27V22.28A5.32,5.32,0,0,0,49.36,17ZM46.25,39.54H8.39a1.92,1.92,0,1,1,0-3.84H46a1.89,1.89,0,0,1,1.91,1.92A1.71,1.71,0,0,1,46.25,39.54Zm0-10.55H8.39a1.92,1.92,0,1,1,0-3.83H46a1.89,1.89,0,0,1,1.91,1.92A1.84,1.84,0,0,1,46.25,29Z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div class="text-container">
            <h2>{{ steps[1].title }}</h2>
            <p v-for="(sub, index) in steps[1].subtitle" :key="index">
              {{ sub }}
            </p>
          </div>
        </div>
        <div class="button-container">
          <button v-on:click="openLink(steps[1].link)">
            {{ steps[1].buttonText }}
          </button>
        </div>
      </div>
    </div>
    <div class="center-bottom-card">
      <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++ Step 3 +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
      <div id="step3" class="card">
        <div class="card-title" style="background-color: #00247c">
          <h1>STEP 3</h1>
        </div>
        <div id="step4-content">
          <div id="step4-rounded-img" class="rounded-img">
            <svg
              id="step4-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 160.95 113.27"
            >
              <g id="Layer_2" data-name="Layer 2">
                <g id="Overlay">
                  <path
                    class="stp3-1"
                    d="M148.1,94.23V12.8A12.82,12.82,0,0,0,135.29,0H25.64a12.82,12.82,0,0,0-12.8,12.8V94.22H0s1.67,19,12.84,19H148.11c11.16,0,12.84-19,12.84-19H148.1ZM93.6,106.38H67.34a3.12,3.12,0,1,1,0-6.24H93.6a3.12,3.12,0,0,1,0,6.24Zm44.65-12.15H22.68V12.8a3,3,0,0,1,3-3H135.29a3,3,0,0,1,3,3Z"
                  />
                  <path
                    class="stp3-2"
                    d="M69.86,18.72a2,2,0,0,0-2,2V32.87a2,2,0,0,0,4,0V20.74A2,2,0,0,0,69.86,18.72ZM52,26.11a2,2,0,0,0-1.42,3.48l7.14,7.13a2,2,0,0,0,2.87-2.87l-7.14-7.14A2.08,2.08,0,0,0,52,26.11Zm35.76,0a2.12,2.12,0,0,0-1.46.6l-7.14,7.14A2,2,0,0,0,82,36.72l7.14-7.13a2,2,0,0,0-1.42-3.48Zm-24.8,13L81.29,87.45,88,72.7l12.88,12.85L109.4,77,96.55,64.11l14.75-6.67ZM44.59,44a2,2,0,1,0,0,4H56.72a2,2,0,1,0,0-4ZM59.15,54.7a2,2,0,0,0-1.45.6l-7.14,7.13a2,2,0,0,0,2.87,2.88l7.14-7.14a2,2,0,0,0,0-2.87A2,2,0,0,0,59.15,54.7Z"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div class="text-container">
            <h2>{{ steps[2].title }}</h2>
            <p v-for="(sub, index) in steps[2].subtitle" :key="index">
              {{ sub }}
            </p>
          </div>
        </div>
        <div class="button-container">
          <button v-on:click="openLink(steps[2].link)">
            {{ steps[2].buttonText }}
          </button>
        </div>
      </div>
    </div>
    <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++ Step 4 +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
    <div class="center-bottom-card">
      <div id="step4" class="card">
        <div class="card-title" style="background-color: #00247c">
          <h1>STEP 4</h1>
        </div>
        <div id="step4-content">
          <div id="step4-rounded-img" class="rounded-img">
            <svg  id="step4-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 170.4 174.8"><clipPath id="clip-path"><path class="stp4-1" d="M2.4,47.06v80.68a10.59,10.59,0,0,0,6.06,9.57l72.23,34.08a10.55,10.55,0,0,0,9,0l72.23-34.08a10.59,10.59,0,0,0,6.06-9.57V47.06a10.58,10.58,0,0,0-6.06-9.57L89.71,3.41a10.55,10.55,0,0,0-9,0L8.46,37.49A10.58,10.58,0,0,0,2.4,47.06Z"/></clipPath><g id="Layer_2" data-name="Layer 2"><g id="Overlay"><path class="stp4-2" d="M2.4,47.06v80.68a10.59,10.59,0,0,0,6.06,9.57l72.23,34.08a10.55,10.55,0,0,0,9,0l72.23-34.08a10.59,10.59,0,0,0,6.06-9.57V47.06a10.58,10.58,0,0,0-6.06-9.57L89.71,3.41a10.55,10.55,0,0,0-9,0L8.46,37.49A10.58,10.58,0,0,0,2.4,47.06Z"/><g class="stp4-3"><rect class="stp4-4" x="2.4" y="64.19" width="165.6" height="55.05"/></g><path class="stp4-5" d="M2.4,47.06v80.68a10.59,10.59,0,0,0,6.06,9.57l72.23,34.08a10.55,10.55,0,0,0,9,0l72.23-34.08a10.59,10.59,0,0,0,6.06-9.57V47.06a10.58,10.58,0,0,0-6.06-9.57L89.71,3.41a10.55,10.55,0,0,0-9,0L8.46,37.49A10.58,10.58,0,0,0,2.4,47.06Z"/><path class="stp4-6" d="M57.1,33.28l1.37-.12a2.91,2.91,0,0,0,.45,1.34,2.47,2.47,0,0,0,1.09.85,4.3,4.3,0,0,0,1.68.32,4,4,0,0,0,1.45-.24,2,2,0,0,0,.94-.68,1.51,1.51,0,0,0,.31-.93,1.49,1.49,0,0,0-.29-.9,2.24,2.24,0,0,0-1-.64c-.29-.11-.94-.29-1.94-.53a10,10,0,0,1-2.1-.68,3,3,0,0,1-1.17-1,2.5,2.5,0,0,1-.38-1.35A2.82,2.82,0,0,1,58,27.15a2.9,2.9,0,0,1,1.37-1.09,5.13,5.13,0,0,1,2-.37,5.48,5.48,0,0,1,2.14.39,3.07,3.07,0,0,1,1.42,1.15A3.39,3.39,0,0,1,65.46,29l-1.39.1a2.2,2.2,0,0,0-.75-1.56,3,3,0,0,0-1.9-.53,3.06,3.06,0,0,0-1.91.48,1.45,1.45,0,0,0-.6,1.16,1.24,1.24,0,0,0,.43,1,5.66,5.66,0,0,0,2.17.77,14.39,14.39,0,0,1,2.41.7,3.24,3.24,0,0,1,1.41,1.11,2.74,2.74,0,0,1,.45,1.55,3,3,0,0,1-.49,1.64,3.3,3.3,0,0,1-1.44,1.2,5.05,5.05,0,0,1-2.1.43,6.45,6.45,0,0,1-2.48-.43,3.47,3.47,0,0,1-1.57-1.3A3.68,3.68,0,0,1,57.1,33.28Z"/><path class="stp4-6" d="M67.59,36.78V25.88h1.34v6.21l3.17-3.21h1.73l-3,2.93,3.33,5H72.49l-2.61-4-.95.91v3.13Z"/><path class="stp4-6" d="M75.21,27.42V25.88h1.34v1.54Zm0,9.36v-7.9h1.34v7.9Z"/><path class="stp4-6" d="M78.56,36.78V25.88H79.9v10.9Z"/><path class="stp4-6" d="M81.94,36.78V25.88h1.34v10.9Z"/><path class="stp4-6" d="M84.82,34.42l1.32-.21a1.9,1.9,0,0,0,.63,1.23,2.17,2.17,0,0,0,1.42.42,2.11,2.11,0,0,0,1.37-.38A1.11,1.11,0,0,0,90,34.6a.82.82,0,0,0-.4-.71,5.92,5.92,0,0,0-1.37-.46,11.94,11.94,0,0,1-2-.64,1.93,1.93,0,0,1-.86-.75,2,2,0,0,1,0-2,2.24,2.24,0,0,1,.65-.75,3,3,0,0,1,.86-.39A4.2,4.2,0,0,1,88,28.7a4.58,4.58,0,0,1,1.64.27,2.21,2.21,0,0,1,1,.73,2.67,2.67,0,0,1,.46,1.22l-1.31.18a1.38,1.38,0,0,0-.51-1,1.89,1.89,0,0,0-1.21-.35,2.23,2.23,0,0,0-1.32.31.88.88,0,0,0-.39.71.72.72,0,0,0,.16.47,1.19,1.19,0,0,0,.51.36c.14.05.53.16,1.19.34a16.29,16.29,0,0,1,2,.62,2.05,2.05,0,0,1,.88.7,2,2,0,0,1,.32,1.15A2.23,2.23,0,0,1,91,35.72a2.54,2.54,0,0,1-1.13.92A4.16,4.16,0,0,1,88.2,37a3.7,3.7,0,0,1-2.35-.64A3,3,0,0,1,84.82,34.42Z"/><path class="stp4-6" d="M97.53,36.78V29.92H96.34v-1h1.19V28a3.52,3.52,0,0,1,.14-1.18,1.71,1.71,0,0,1,.68-.85,2.49,2.49,0,0,1,1.36-.32,6.4,6.4,0,0,1,1.25.13l-.2,1.17a4.45,4.45,0,0,0-.79-.07,1.15,1.15,0,0,0-.86.26,1.4,1.4,0,0,0-.25,1v.73h1.54v1H98.86v6.86Z"/><path class="stp4-6" d="M100.94,32.83a4.08,4.08,0,0,1,1.22-3.25,3.71,3.71,0,0,1,2.48-.88,3.56,3.56,0,0,1,2.67,1.07,4.06,4.06,0,0,1,1,2.95,5.15,5.15,0,0,1-.46,2.4,3.29,3.29,0,0,1-1.33,1.36,3.9,3.9,0,0,1-1.91.48A3.55,3.55,0,0,1,102,35.9,4.26,4.26,0,0,1,100.94,32.83Zm1.38,0A3.36,3.36,0,0,0,103,35.1a2.19,2.19,0,0,0,3.32,0,3.46,3.46,0,0,0,.67-2.31,3.27,3.27,0,0,0-.67-2.22,2.2,2.2,0,0,0-3.32,0A3.36,3.36,0,0,0,102.32,32.83Z"/><path class="stp4-6" d="M109.9,36.78v-7.9h1.2v1.2A3.34,3.34,0,0,1,112,29a1.49,1.49,0,0,1,.86-.27,2.71,2.71,0,0,1,1.38.43l-.46,1.25a1.88,1.88,0,0,0-1-.29,1.22,1.22,0,0,0-.78.26,1.42,1.42,0,0,0-.5.73,5.22,5.22,0,0,0-.23,1.57v4.13Z"/><path class="stp4-6" d="M28.37,53.62V42.71h4.12a9.65,9.65,0,0,1,1.65.11,3.28,3.28,0,0,1,1.35.51,2.67,2.67,0,0,1,.87,1.05,3.23,3.23,0,0,1,.34,1.49,3.34,3.34,0,0,1-.89,2.35,4.26,4.26,0,0,1-3.2,1h-2.8v4.43Zm1.44-5.72h2.82a3,3,0,0,0,2-.52,1.88,1.88,0,0,0,.59-1.47,2,2,0,0,0-.35-1.17A1.6,1.6,0,0,0,34,44.1,5.76,5.76,0,0,0,32.6,44H29.81Z"/><path class="stp4-6" d="M38.35,53.62v-7.9h1.2v1.2a3.34,3.34,0,0,1,.85-1.11,1.49,1.49,0,0,1,.86-.27,2.61,2.61,0,0,1,1.38.43l-.46,1.24a2,2,0,0,0-1-.29,1.24,1.24,0,0,0-.79.27,1.38,1.38,0,0,0-.5.73,5.21,5.21,0,0,0-.22,1.56v4.14Z"/><path class="stp4-6" d="M42.94,49.67a4,4,0,0,1,1.22-3.25,3.64,3.64,0,0,1,2.48-.88,3.54,3.54,0,0,1,2.66,1.07,4.05,4.05,0,0,1,1,3,5.2,5.2,0,0,1-.46,2.4,3.21,3.21,0,0,1-1.33,1.35,3.8,3.8,0,0,1-1.91.49A3.55,3.55,0,0,1,44,52.73,4.25,4.25,0,0,1,42.94,49.67Zm1.37,0A3.36,3.36,0,0,0,45,51.94a2.2,2.2,0,0,0,3.33,0A3.47,3.47,0,0,0,49,49.62a3.31,3.31,0,0,0-.66-2.22,2.22,2.22,0,0,0-3.33,0A3.36,3.36,0,0,0,44.31,49.67Z"/><path class="stp4-6" d="M51.37,51.26l1.33-.21a1.83,1.83,0,0,0,.62,1.22,2.61,2.61,0,0,0,2.79,0,1.11,1.11,0,0,0,.45-.88.82.82,0,0,0-.4-.71,5.92,5.92,0,0,0-1.37-.46,12.94,12.94,0,0,1-2-.64,2,2,0,0,1-1.16-1.81,2,2,0,0,1,.25-1,2.16,2.16,0,0,1,.66-.75,2.82,2.82,0,0,1,.85-.39,3.9,3.9,0,0,1,1.15-.16,4.58,4.58,0,0,1,1.64.27,2.21,2.21,0,0,1,1,.72,2.88,2.88,0,0,1,.47,1.23l-1.31.18a1.47,1.47,0,0,0-.52-1,2,2,0,0,0-1.21-.34,2.17,2.17,0,0,0-1.32.31.88.88,0,0,0-.39.71.74.74,0,0,0,.16.47,1.26,1.26,0,0,0,.52.36c.13,0,.52.16,1.18.34a15.71,15.71,0,0,1,2,.62,2,2,0,0,1,.88.7,1.93,1.93,0,0,1,.32,1.15,2.25,2.25,0,0,1-.39,1.26,2.49,2.49,0,0,1-1.12.91,4.08,4.08,0,0,1-1.67.33,3.76,3.76,0,0,1-2.35-.64A3,3,0,0,1,51.37,51.26Z"/><path class="stp4-6" d="M59.52,56.65V45.72h1.23v1a2.87,2.87,0,0,1,1-.91,2.68,2.68,0,0,1,1.32-.3,3.08,3.08,0,0,1,1.78.52A3.18,3.18,0,0,1,66,47.53a5.43,5.43,0,0,1,.39,2.08A5.24,5.24,0,0,1,66,51.79a3.22,3.22,0,0,1-1.27,1.49,3.18,3.18,0,0,1-1.74.52,2.59,2.59,0,0,1-1.2-.28,2.73,2.73,0,0,1-.88-.72v3.85Zm1.22-6.94A3.47,3.47,0,0,0,61.35,52a1.91,1.91,0,0,0,3,0A3.6,3.6,0,0,0,65,49.6a3.46,3.46,0,0,0-.62-2.26,1.87,1.87,0,0,0-1.48-.75,1.92,1.92,0,0,0-1.51.8A3.56,3.56,0,0,0,60.74,49.71Z"/><path class="stp4-6" d="M73.41,51.08l1.38.17a3.42,3.42,0,0,1-1.21,1.88,3.7,3.7,0,0,1-2.26.67,3.61,3.61,0,0,1-2.75-1.07,4.15,4.15,0,0,1-1-3,4.36,4.36,0,0,1,1-3.1,3.48,3.48,0,0,1,2.66-1.1,3.37,3.37,0,0,1,2.59,1.08,4.28,4.28,0,0,1,1,3V50h-5.9a3,3,0,0,0,.74,2,2.16,2.16,0,0,0,1.65.7,2.05,2.05,0,0,0,1.26-.39A2.62,2.62,0,0,0,73.41,51.08ZM69,48.91h4.41a2.65,2.65,0,0,0-.51-1.49,2,2,0,0,0-1.65-.78,2.15,2.15,0,0,0-1.56.62A2.45,2.45,0,0,0,69,48.91Z"/><path class="stp4-6" d="M76.46,53.62v-7.9h1.2v1.2a3.34,3.34,0,0,1,.85-1.11,1.49,1.49,0,0,1,.86-.27,2.61,2.61,0,0,1,1.38.43l-.46,1.24a2,2,0,0,0-1-.29,1.23,1.23,0,0,0-.78.27,1.38,1.38,0,0,0-.5.73,5.2,5.2,0,0,0-.23,1.56v4.14Z"/><path class="stp4-6" d="M81.55,44.25V42.71h1.34v1.54Zm0,9.37v-7.9h1.34v7.9Z"/><path class="stp4-6" d="M87.85,52.42l.2,1.18a5,5,0,0,1-1,.12,2.24,2.24,0,0,1-1.13-.23,1.25,1.25,0,0,1-.56-.6,4.72,4.72,0,0,1-.17-1.58V46.76h-1v-1h1v-2l1.34-.8v2.76h1.34v1H86.51v4.62a2.29,2.29,0,0,0,.07.74.52.52,0,0,0,.23.26.92.92,0,0,0,.45.09A3.58,3.58,0,0,0,87.85,52.42Z"/><path class="stp4-6" d="M89.1,56.66,89,55.4a3,3,0,0,0,.77.12,1.44,1.44,0,0,0,.71-.15,1.08,1.08,0,0,0,.44-.41,6.5,6.5,0,0,0,.41-1c0-.07.06-.18.12-.33l-3-7.91h1.44l1.65,4.57q.32.87.57,1.83c.16-.61.34-1.21.55-1.8l1.69-4.6h1.34l-3,8a15.44,15.44,0,0,1-.75,1.8,2.69,2.69,0,0,1-.82,1,2,2,0,0,1-1.1.31A2.72,2.72,0,0,1,89.1,56.66Z"/><path class="stp4-6" d="M101.12,53.62V42.71h1.44v5.41L108,42.71h2l-4.58,4.42,4.78,6.49h-1.91l-3.88-5.52-1.79,1.74v3.78Z"/><path class="stp4-6" d="M116.58,51.08l1.38.17a3.42,3.42,0,0,1-1.21,1.88,3.68,3.68,0,0,1-2.26.67,3.62,3.62,0,0,1-2.75-1.07,4.15,4.15,0,0,1-1-3,4.41,4.41,0,0,1,1-3.1,3.49,3.49,0,0,1,2.66-1.1A3.37,3.37,0,0,1,117,46.62a4.28,4.28,0,0,1,1,3c0,.08,0,.2,0,.36h-5.89a3,3,0,0,0,.73,2,2.2,2.2,0,0,0,1.66.7,2,2,0,0,0,1.25-.39A2.55,2.55,0,0,0,116.58,51.08Zm-4.4-2.17h4.41a2.65,2.65,0,0,0-.5-1.49,2.05,2.05,0,0,0-1.66-.78,2.13,2.13,0,0,0-1.55.62A2.46,2.46,0,0,0,112.18,48.91Z"/><path class="stp4-6" d="M119.64,53.62v-7.9h1.21v1.12a2.83,2.83,0,0,1,2.51-1.3,3.34,3.34,0,0,1,1.32.26,2,2,0,0,1,.89.67,2.6,2.6,0,0,1,.42,1,7.74,7.74,0,0,1,.07,1.3v4.86h-1.34V48.81a3.74,3.74,0,0,0-.15-1.22,1.31,1.31,0,0,0-.56-.65,1.74,1.74,0,0,0-.93-.24,2.2,2.2,0,0,0-1.48.54A2.71,2.71,0,0,0,121,49.3v4.32Z"/><path class="stp4-6" d="M128.06,56.66l-.15-1.26a3,3,0,0,0,.76.12,1.48,1.48,0,0,0,.72-.15,1.15,1.15,0,0,0,.44-.41,7.79,7.79,0,0,0,.41-1q0-.1.12-.33l-3-7.91h1.44l1.64,4.57a18.68,18.68,0,0,1,.58,1.83,16.24,16.24,0,0,1,.55-1.8l1.69-4.6h1.34l-3,8a15.44,15.44,0,0,1-.75,1.8,2.69,2.69,0,0,1-.82,1,2,2,0,0,1-1.1.31A2.62,2.62,0,0,1,128.06,56.66Z"/><path class="stp4-6" d="M140.89,52.64a5,5,0,0,1-1.43.9,4.22,4.22,0,0,1-1.48.26,2.84,2.84,0,0,1-2-.64,2.07,2.07,0,0,1-.7-1.62,2.22,2.22,0,0,1,.26-1.06,2.17,2.17,0,0,1,.7-.77,3,3,0,0,1,1-.44,8.66,8.66,0,0,1,1.19-.2,13.07,13.07,0,0,0,2.39-.46v-.35a1.51,1.51,0,0,0-.37-1.16,2.29,2.29,0,0,0-1.53-.45,2.35,2.35,0,0,0-1.39.33,2,2,0,0,0-.67,1.17L135.51,48a3.23,3.23,0,0,1,.59-1.35,2.53,2.53,0,0,1,1.18-.8,5.18,5.18,0,0,1,1.79-.28,4.72,4.72,0,0,1,1.65.24,2.2,2.2,0,0,1,.93.6,2.06,2.06,0,0,1,.41.91,6.86,6.86,0,0,1,.07,1.23v1.79a18,18,0,0,0,.09,2.36,3,3,0,0,0,.33.95h-1.39A2.82,2.82,0,0,1,140.89,52.64Zm-.11-3a9.88,9.88,0,0,1-2.19.51,5.08,5.08,0,0,0-1.17.27,1.11,1.11,0,0,0-.71,1.07,1.13,1.13,0,0,0,.4.89,1.75,1.75,0,0,0,1.19.36,2.74,2.74,0,0,0,1.38-.34,2.08,2.08,0,0,0,.88-.93,3.07,3.07,0,0,0,.22-1.33Z"/><path class="stp4-6" d="M53.34,144.72V127.5h5.58a19.7,19.7,0,0,1,4.14.26,4.52,4.52,0,0,1,2.47,1.68,5.35,5.35,0,0,1,1,3.36,5.66,5.66,0,0,1-.57,2.66,4.79,4.79,0,0,1-1.46,1.7,5.3,5.3,0,0,1-1.81.82,20.34,20.34,0,0,1-3.6.24H56.82v6.5Zm3.48-14.31v4.89h1.9a9,9,0,0,0,2.75-.27A2.26,2.26,0,0,0,63,132.84a2.23,2.23,0,0,0-.55-1.55,2.4,2.4,0,0,0-1.4-.76,16.31,16.31,0,0,0-2.5-.12Z"/><path class="stp4-6" d="M72.07,136.05l-3-.54a4.63,4.63,0,0,1,1.73-2.68,6.39,6.39,0,0,1,3.67-.87,8.06,8.06,0,0,1,3.29.52,3.36,3.36,0,0,1,1.52,1.33,6.89,6.89,0,0,1,.44,3l0,3.85a13.87,13.87,0,0,0,.16,2.42,7.38,7.38,0,0,0,.59,1.68H77.18c-.09-.22-.19-.55-.32-1a3.27,3.27,0,0,0-.12-.39,6,6,0,0,1-1.8,1.24,5.3,5.3,0,0,1-2.06.41,4.26,4.26,0,0,1-3-1.05,3.45,3.45,0,0,1-1.11-2.64,3.51,3.51,0,0,1,.51-1.88,3.27,3.27,0,0,1,1.41-1.27,10.94,10.94,0,0,1,2.63-.77,18.31,18.31,0,0,0,3.21-.81v-.33a1.72,1.72,0,0,0-.47-1.36,2.86,2.86,0,0,0-1.78-.4,2,2,0,0,0-2.17,1.56Zm4.42,2.68a20.61,20.61,0,0,1-2,.5,6,6,0,0,0-1.8.58A1.36,1.36,0,0,0,72,141a1.64,1.64,0,0,0,.51,1.2,1.84,1.84,0,0,0,1.32.5,2.86,2.86,0,0,0,1.7-.58,2.13,2.13,0,0,0,.79-1.1,6.77,6.77,0,0,0,.13-1.61Z"/><path class="stp4-6" d="M86.38,144.72h-3.3V132.24h3.07V134a5.3,5.3,0,0,1,1.41-1.66A2.59,2.59,0,0,1,89,132a4.21,4.21,0,0,1,2.17.62l-1,2.88a2.87,2.87,0,0,0-1.55-.54,1.85,1.85,0,0,0-1.17.38,2.57,2.57,0,0,0-.76,1.38,19.14,19.14,0,0,0-.28,4.18Z"/><path class="stp4-6" d="M98.54,132.24v2.63H96.29v5a13.46,13.46,0,0,0,.06,1.78.74.74,0,0,0,.3.42.93.93,0,0,0,.56.16,4.06,4.06,0,0,0,1.32-.32l.28,2.57a6.66,6.66,0,0,1-2.6.49,4.13,4.13,0,0,1-1.61-.3,2.3,2.3,0,0,1-1-.78,3,3,0,0,1-.47-1.28,16.47,16.47,0,0,1-.1-2.33v-5.44H91.46v-2.63H93v-2.47l3.31-1.93v4.4Z"/><path class="stp4-6" d="M114.9,144.72h-3.31V132.28a11.25,11.25,0,0,1-4.26,2.5v-3a9.72,9.72,0,0,0,2.81-1.61,6.07,6.07,0,0,0,2.08-2.75h2.68Z"/><path class="stp4-6" d="M51.25,79.74A10.4,10.4,0,0,1,52,75.62a7.67,7.67,0,0,1,1.5-2.2A6.23,6.23,0,0,1,55.56,72,8.86,8.86,0,0,1,59,71.33a7.57,7.57,0,0,1,5.69,2.21,8.45,8.45,0,0,1,2.13,6.13,8.4,8.4,0,0,1-2.12,6.08A7.46,7.46,0,0,1,59.07,88a7.59,7.59,0,0,1-5.7-2.18A8.32,8.32,0,0,1,51.25,79.74Zm3.34-.11a6,6,0,0,0,1.26,4.14,4.34,4.34,0,0,0,6.39,0,6.13,6.13,0,0,0,1.24-4.19,6,6,0,0,0-1.21-4.12,4.08,4.08,0,0,0-3.22-1.36,4.15,4.15,0,0,0-3.23,1.37A6.07,6.07,0,0,0,54.59,79.63Z"/><path class="stp4-6" d="M79.94,87.68H76.86V81.74a9.21,9.21,0,0,0-.2-2.44,1.65,1.65,0,0,0-.64-.86A1.8,1.8,0,0,0,75,78.13a2.52,2.52,0,0,0-1.44.44,2.24,2.24,0,0,0-.87,1.16,10.48,10.48,0,0,0-.23,2.68v5.27H69.33V76h2.86v1.71a4.64,4.64,0,0,1,3.83-2,4.73,4.73,0,0,1,1.87.37,3.21,3.21,0,0,1,1.28.94,3.47,3.47,0,0,1,.6,1.29,9.79,9.79,0,0,1,.17,2.07Z"/><path class="stp4-6" d="M83.06,87.68V71.61h3.08V87.68Z"/><path class="stp4-6" d="M89.3,74.46V71.61h3.08v2.85Zm0,13.22V76h3.08V87.68Z"/><path class="stp4-6" d="M106.13,87.68h-3.08V81.74a9.21,9.21,0,0,0-.2-2.44,1.71,1.71,0,0,0-.64-.86,1.8,1.8,0,0,0-1.07-.31,2.52,2.52,0,0,0-1.44.44,2.24,2.24,0,0,0-.87,1.16,10,10,0,0,0-.23,2.68v5.27H95.52V76h2.86v1.71a4.64,4.64,0,0,1,3.83-2,4.76,4.76,0,0,1,1.87.37,3.11,3.11,0,0,1,1.27.94,3.49,3.49,0,0,1,.61,1.29,9.79,9.79,0,0,1,.17,2.07Z"/><path class="stp4-6" d="M116,84l3.07.52a5,5,0,0,1-1.87,2.57,5.45,5.45,0,0,1-3.19.88,5.21,5.21,0,0,1-4.5-2,6.72,6.72,0,0,1-1.15-4,6.45,6.45,0,0,1,1.52-4.54,5,5,0,0,1,3.82-1.64,5.18,5.18,0,0,1,4.1,1.72c1,1.14,1.48,2.9,1.44,5.26h-7.72a3.09,3.09,0,0,0,.75,2.13,2.3,2.3,0,0,0,1.77.76,1.92,1.92,0,0,0,1.22-.39A2.47,2.47,0,0,0,116,84Zm.18-3.11a2.94,2.94,0,0,0-.69-2,2.1,2.1,0,0,0-1.6-.7,2.16,2.16,0,0,0-1.67.74,2.86,2.86,0,0,0-.65,2Z"/><path class="stp4-6" d="M32.58,111.73V95.66H44.49v2.72H35.82v3.56h8.07v2.71H35.82V109h9v2.7Z"/><path class="stp4-6" d="M58.21,111.73H55.35V110a4.67,4.67,0,0,1-1.69,1.49,4.36,4.36,0,0,1-1.95.49,4.43,4.43,0,0,1-3.44-1.62,6.6,6.6,0,0,1-1.43-4.51,6.5,6.5,0,0,1,1.39-4.5,4.53,4.53,0,0,1,3.52-1.54,4.37,4.37,0,0,1,3.38,1.62V95.66h3.08ZM50,105.66a5.41,5.41,0,0,0,.51,2.7,2.33,2.33,0,0,0,2.08,1.2,2.28,2.28,0,0,0,1.81-.9,4.16,4.16,0,0,0,.75-2.7,4.52,4.52,0,0,0-.73-2.89,2.28,2.28,0,0,0-1.85-.88,2.33,2.33,0,0,0-1.84.87A4,4,0,0,0,50,105.66Z"/><path class="stp4-6" d="M68.91,111.73V110a4.6,4.6,0,0,1-1.68,1.47,4.66,4.66,0,0,1-2.18.54,4.31,4.31,0,0,1-2.11-.52A3.06,3.06,0,0,1,61.59,110a6.6,6.6,0,0,1-.41-2.57v-7.37h3.08v5.35a14.31,14.31,0,0,0,.17,3,1.64,1.64,0,0,0,.62.88,1.94,1.94,0,0,0,1.14.32,2.42,2.42,0,0,0,1.41-.43,2.24,2.24,0,0,0,.86-1.08,12.58,12.58,0,0,0,.23-3.14v-4.91h3.08v11.64Z"/><path class="stp4-6" d="M85.11,103.53l-3,.55a2.19,2.19,0,0,0-.69-1.37,2.12,2.12,0,0,0-1.41-.46,2.31,2.31,0,0,0-1.84.8,4,4,0,0,0-.68,2.65,4.74,4.74,0,0,0,.69,2.93,2.3,2.3,0,0,0,1.87.86,2.1,2.1,0,0,0,1.44-.5,3.11,3.11,0,0,0,.79-1.72l3,.52a5.34,5.34,0,0,1-1.81,3.14A5.57,5.57,0,0,1,79.87,112a5.31,5.31,0,0,1-4.07-1.62,6.2,6.2,0,0,1-1.52-4.46,6.29,6.29,0,0,1,1.52-4.49,5.42,5.42,0,0,1,4.12-1.6,5.6,5.6,0,0,1,3.38.91A5.08,5.08,0,0,1,85.11,103.53Z"/><path class="stp4-6" d="M89.75,103.64l-2.8-.5a4.35,4.35,0,0,1,1.62-2.5A6,6,0,0,1,92,99.83a7.26,7.26,0,0,1,3.07.49,3,3,0,0,1,1.42,1.23,6.3,6.3,0,0,1,.41,2.76l0,3.6a12.25,12.25,0,0,0,.15,2.26,6.51,6.51,0,0,0,.55,1.56h-3c-.08-.2-.17-.5-.29-.91,0-.18-.09-.3-.11-.36a5.52,5.52,0,0,1-1.69,1.15,4.78,4.78,0,0,1-1.92.39,4,4,0,0,1-2.83-1,3.25,3.25,0,0,1-1-2.47,3.38,3.38,0,0,1,.47-1.76,3.15,3.15,0,0,1,1.32-1.18,10.89,10.89,0,0,1,2.46-.72,17.57,17.57,0,0,0,3-.75v-.31a1.61,1.61,0,0,0-.44-1.27,2.64,2.64,0,0,0-1.66-.37,1.83,1.83,0,0,0-2,1.45Zm4.12,2.5a19.24,19.24,0,0,1-1.88.47,6,6,0,0,0-1.67.54,1.29,1.29,0,0,0-.61,1.09,1.47,1.47,0,0,0,.49,1.11,1.66,1.66,0,0,0,1.22.48,2.69,2.69,0,0,0,1.59-.55,2,2,0,0,0,.74-1,6.18,6.18,0,0,0,.12-1.5Z"/><path class="stp4-6" d="M105.27,100.09v2.46h-2.11v4.69a11.74,11.74,0,0,0,.06,1.66.68.68,0,0,0,.28.39.86.86,0,0,0,.52.15,4.19,4.19,0,0,0,1.24-.29l.26,2.39a6.26,6.26,0,0,1-2.43.46,3.93,3.93,0,0,1-1.5-.28,2.21,2.21,0,0,1-1-.73,2.9,2.9,0,0,1-.43-1.2,15.78,15.78,0,0,1-.1-2.17v-5.07H98.66v-2.46h1.41V97.78l3.09-1.8v4.11Z"/><path class="stp4-6" d="M107.41,98.51V95.66h3.08v2.85Zm0,13.22V100.09h3.08v11.64Z"/><path class="stp4-6" d="M112.93,105.75a6.19,6.19,0,0,1,.76-3,5.22,5.22,0,0,1,2.14-2.2,6.43,6.43,0,0,1,3.1-.75,5.83,5.83,0,0,1,4.33,1.71,6.44,6.44,0,0,1,0,8.72A5.77,5.77,0,0,1,119,112a6.75,6.75,0,0,1-3-.73,4.93,4.93,0,0,1-2.21-2.12A7,7,0,0,1,112.93,105.75Zm3.16.16a3.82,3.82,0,0,0,.82,2.65,2.67,2.67,0,0,0,4,0,3.86,3.86,0,0,0,.82-2.67,3.8,3.8,0,0,0-.82-2.63,2.69,2.69,0,0,0-4,0A3.84,3.84,0,0,0,116.09,105.91Z"/><path class="stp4-6" d="M138,111.73h-3.08v-5.94a9.21,9.21,0,0,0-.2-2.44,1.75,1.75,0,0,0-.64-.86,1.87,1.87,0,0,0-1.07-.3,2.51,2.51,0,0,0-1.44.43,2.26,2.26,0,0,0-.87,1.17,9.94,9.94,0,0,0-.23,2.67v5.27h-3.08V100.09h2.86v1.71a4.66,4.66,0,0,1,3.83-2,4.59,4.59,0,0,1,1.87.37,3,3,0,0,1,1.27.93,3.46,3.46,0,0,1,.61,1.3,9.79,9.79,0,0,1,.17,2.07Z"/></g></g></svg>
          </div>
          <div class="text-container">
            <h2>{{ steps[3].title }}</h2>
            <p v-for="(sub, index) in steps[3].subtitle" :key="index">
              {{ sub }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++ Step 5 +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
    <div class="center-bottom-card">
      <div id="step5" class="card">
        <div class="card-title" style="background-color: #00247c">
          <h1>STEP 5</h1>
        </div>
        <div id="step4-content">
          <div id="step4-rounded-img" class="rounded-img">

            <img :src="require('./assets/Step-5.png')"/>
          </div>
          <div class="text-container">
            <h2>{{ steps[4].title }}</h2>
            <p v-for="(sub, index) in steps[4].subtitle" :key="index">
              {{ sub }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- +++++++++++++++++++++++++++++++++++++++++++++++++++++++ Step 6 +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
    <div class="center-bottom-card">
      <div id="step6" class="card">
        <div class="card-title" style="background-color: #00247c">
          <h1>STEP 6</h1>
        </div>
        <div id="step4-content">
          <div id="step4-rounded-img" class="rounded-img">
            <svg
              id="step4-svg"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 108.77 151.31"
            >
              <g id="Layer_2" data-name="Layer 2">
                <g id="Overlay">
                  <path
                    class="stp1-1"
                    d="M89.79,17.5H86.94a1.41,1.41,0,0,0-1.41,1.42v5.34a1.4,1.4,0,0,0,1.38,1.42h2.88a10.78,10.78,0,0,1,10.79,10.78v95.88a10.79,10.79,0,0,1-10.77,10.8H19a10.79,10.79,0,0,1-10.8-10.77V36.48a10.77,10.77,0,0,1,10.76-10.8h2.88a1.41,1.41,0,0,0,1.42-1.39V18.92a1.41,1.41,0,0,0-1.42-1.42H19a19,19,0,0,0-19,19H0v95.86a19,19,0,0,0,19,19H89.79a19,19,0,0,0,19-19V36.48a19,19,0,0,0-19-19Z"
                  />
                  <path
                    class="stp1-2"
                    d="M48.93,50.72a1,1,0,0,0-1,1h0V54a1,1,0,0,0,1,1h40a1,1,0,0,0,1-1V51.67a1,1,0,0,0-1-1h-40Z"
                  />
                  <path
                    class="stp1-2"
                    d="M48.93,58.53a1,1,0,0,0-1,.95h0v2.37a1,1,0,0,0,1,1h40a1,1,0,0,0,1-1V59.48a1,1,0,0,0-1-.95h-40Z"
                  />
                  <path
                    class="stp1-2"
                    d="M48.93,79.51a1,1,0,0,0-1,.95h0v2.37a1,1,0,0,0,1,1h40a1,1,0,0,0,1-1V80.46a1,1,0,0,0-1-.95h-40Z"
                  />
                  <path
                    class="stp1-2"
                    d="M48.93,87.49a1,1,0,0,0-1,1h0v2.37a1,1,0,0,0,1,1h40a1,1,0,0,0,1-1V88.44a1,1,0,0,0-1-1h-40Z"
                  />
                  <path
                    class="stp1-2"
                    d="M48.93,108.4a1,1,0,0,0-1,.95h0v2.38a1,1,0,0,0,1,1h40a1,1,0,0,0,1-.94h0v-2.35a1,1,0,0,0-1-.95h0Z"
                  />
                  <path
                    class="stp1-2"
                    d="M48.93,115.88a1,1,0,0,0-1,1h0v2.39a1,1,0,0,0,1,1h40a1,1,0,0,0,1-1h0v-2.35a1,1,0,0,0-1-1h0Z"
                  />
                  <path
                    class="stp1-2"
                    d="M75.69,9.9H65.26a10.93,10.93,0,0,0-21.76,0H33.07a2.59,2.59,0,0,0-2.6,2.58V26.34A2.58,2.58,0,0,0,33,29h42.7a2.58,2.58,0,0,0,2.61-2.57V12.51A2.59,2.59,0,0,0,75.73,9.9ZM50.39,7A5.63,5.63,0,0,1,59.92,9.9,4.28,4.28,0,0,1,60,11a5.65,5.65,0,1,1-11.29.11,5.24,5.24,0,0,1,.11-1.18A5.53,5.53,0,0,1,50.39,7Z"
                  />
                  <path
                    class="stp1-1"
                    d="M34.17,59.57v3.57h-12v-12H32.67l3.06-3.41h-17V66.56H37.58V55.79Z"
                  />
                  <polygon
                    class="stp1-2"
                    points="29.95 61.74 23.63 55.65 25.98 53.18 29.78 56.84 39.66 45.81 42.2 48.08 29.95 61.74"
                  />
                  <path
                    class="stp1-1"
                    d="M34.17,88.38V92h-12v-12h10.5l3-3.42h-17V95.35H37.58V84.58Z"
                  />
                  <polygon
                    class="stp1-2"
                    points="29.95 90.54 23.63 84.44 25.98 81.98 29.78 85.63 39.66 74.6 42.2 76.87 29.95 90.54"
                  />
                  <path
                    class="stp1-1"
                    d="M34.17,117.3v3.58h-12v-12H32.67l3.06-3.41h-17v18.86H37.58V113.51Z"
                  />
                  <polygon
                    class="stp1-2"
                    points="29.95 119.46 23.63 113.36 25.98 110.9 29.78 114.55 39.66 103.53 42.2 105.8 29.95 119.46"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div class="text-container">
            <h2>{{ steps[5].title }}</h2>
            <p v-for="(sub, index) in steps[5].subtitle" :key="index">
              {{ sub }}
            </p>
          </div>
        </div>
        <div class="button-container">
          <button v-on:click="openLink(steps[5].link)">
            {{ steps[5].buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "App",
  mounted() {
    window.VLE.resize_iframe();
  },
  updated() {
    window.VLE.resize_iframe();
  },
  data: () => ({
    steps: [
      {
        step: 1,
        title: "Complete the survey",
        subtitle: [
          "Help us to get to know you better to support your learning about online education.",
        ],
        buttonText: "TAKE THE SURVEY",
        link: "https://www.open.edu/openlearncreate/mod/questionnaire/view.php?id=190584",
      },
      {
        step: 2,
        title: "Join your course community of practice",
        subtitle: [
          "Click here and click on the ‘+ Join Group’ button to join the course community of practice (private) Facebook group.",
        ],
        buttonText: "JOIN THE GROUP",
        link: "https://www.facebook.com/groups/550668899635715",
      },
      {
        step: 3,
        title: "Start the course",
        subtitle: [
          "Sign up, sign in and enrol.",
          "Begin by studying the introduction and guidance in Session 1."
        ],
        buttonText: "ACCESS THE COURSE",
        link: "https://www.open.edu/openlearncreate/course/view.php?id=8456",
      },
      {
        step: 4,
        title: "Earn a digital badge",
        subtitle: [
          "Successfully complete the quiz at the end of Session 4 and claim your first digital badge.",
        ],
      },
      {
        step: 5,
        title:
          "Earn your digital badge and claim your certificate of completion",
        subtitle: [
          "Successfully complete the quiz at the end of Session 8 to earn your second digital badge and certificate of completion.",
          "Both digital badges can be added to your CV and LinkedIn profile to show what you have learned.",
        ],
      },
      {
        step: 6,
        title: "Complete the end-of-course survey",
        subtitle: [
          "Help us to understand how much you have learned and how effective our teaching has been.",
        ],
        buttonText: "TAKE THE END-OF-COURSE SURVEY",
        link: "https://www.open.edu/openlearncreate/mod/questionnaire/view.php?id=190585",
      },
    ],
  }),
  methods: {
    openLink(link) {
      window.open(link, "_blank");

      window.VLE.get_olink_url(
        this.link,
        "",
        (url) => (window.parent.location.href = url),
        (err) => console.log("Olink error for OLC Africa: ", err)
      );
    },
  },
};
</script>

<style>
h1,
h2,
p {
  font-family: Arial, Helvetica, sans-serif;
}
h1 {
  color: #ffffff;
}
p,
h2 {
  color: #000000;
}
h1 {
  font-size: 2em;
  margin: 0px;
  font-weight: bold;
}
h2 {
  font-size: 1.5em;
  font-weight: bold;
}
p {
  font-size: 1.12em;
  margin-bottom: 0px;
}
#step3-text h2 {
  font-size: 2em;
  margin-top: 0.5em;
}
html,
body,
#app {
  width: 100%;
  display: flex;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.top-card,
.bottom-card {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 15px;
  flex-grow: 1;
}
.center-card,
.center-bottom-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 15px;
}
.card {
  /*background-color: #f3ece3;*/
  background-color: #e5e9f2;
  width: 100%;
}
#step1,
#step2,
#step3,
#step4,
#step5,
#step6 {
  display: flex;
  flex-direction: column;
}
.card-title {
  padding-top: 10px;
  padding-bottom: 10px;
}
.text-container {
  margin-top: 10px;
  padding-left: 1.3em;
  padding-right: 1.3em;
}
#step1-content,
#step2-content,
#step4-content,
#step5-content,
#step6-content {
  padding: 1.2em;
}
#step3-content {
  padding-left: 1.2em;
  padding-right: 1.2em;
  padding-bottom: 1.2em;
}
#step4-content {
  display: flex;
  flex-direction: row;
  text-align: left;
}
.button-container {
  margin-bottom: 1.5em;
  margin-left: 1.5em;
  margin-right: 1.5em;
  margin-top: auto;
}
.button-container button {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 1.2em;
  font-weight: bold;
  background-color: #c1142b;
  color: #ffffff;
  border-radius: 5px;
  border: 0px solid black;
}
.button-container button:focus {
  background-color: #961022;
  outline: 2px solid #961022;
}
.button-container button:hover {
  background-color: #961022;
}
/* SVGs */
.rounded-img {
}
#step1-svg {
  max-width: 155px;
}
#step2-svg {
  max-width: 200px;
}
#step3-svg {
  max-width: 155px;
}
#step4-svg {
  max-width: 160px;
  min-width: 160px;
}
#step5-svg {
  max-width: 215px;
}
#step6-svg {
  max-width: 155px;
}
.stp1-1 {
  fill: #c1142b;
}
.stp1-2 {
  fill: #00247c;
}
.stp2-1 {
  fill: #c1142b;
}
.stp2-2 {
  fill: #00247c;
}
.stp3-1 {
  fill: #c1142b;
}
.stp3-2 {
  fill: #00247c;
}
.stp4-1,.stp4-2{fill:#00247c;}.stp4-1,.stp4-5{stroke:#8091bd;stroke-miterlimit:10;stroke-width:4.8px;}.stp4-3{clip-path:url(#clip-path);}.stp4-4{fill:#c2142b;}.stp4-5{fill:none;}.stp4-6{fill:#fff;}

.stp5-1{fill:#fff;}.stp5-16,.stp5-2{fill:#00247c;}.stp5-19,.stp5-2{stroke:#8091bd;stroke-width:1.83px;}.stp5-14,.stp5-15,.stp5-19,.stp5-2{stroke-miterlimit:10;}.stp5-3{isolation:isolate;}.stp5-4{clip-path:url(#clip-path);}.stp5-5,.stp5-9{fill:#23346a;}.stp5-5{mix-blend-mode:hard-light;}.stp5-6{fill:#d3d6df;}.stp5-6,.stp5-7,.stp5-8,.stp5-9{mix-blend-mode:multiply;}.stp5-7{fill:#f5d0d3;}.stp5-8{fill:#ce1321;}.stp5-10{fill:#223061;}.stp5-11,.stp5-14,.stp5-15,.stp5-19{fill:none;}.stp5-12{fill:#1e4c9a;}.stp5-13{fill:#ce1322;}.stp5-14{stroke:#223061;}.stp5-14,.stp5-15{stroke-width:0.21px;}.stp5-15{stroke:#ce1322;stroke-dasharray:0.32;}.stp5-17{clip-path:url(#clip-path-2);}.stp5-18{fill:#c2142b;}
/* Media queries */
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .top-card,
  .bottom-card {
    flex-direction: column;
  }
  #step1,
  #step2,
  #step5,
  #step6 {
    margin: 0px;
  }
  #step1,
  #step5 {
    margin-bottom: 15px;
  }
  #step4-content {
    flex-direction: column;
  }
  #pathway1,
  #pathway2,
  #pathway3,
  #pathway4,
  #pathway5,
  #pathway6 {
    flex-direction: column;
  }
  .pathway-buttons button {
    height: auto;
    max-height: unset;
    word-break: break-word;
  }
  #step4-svg {
    max-width: unset;
    min-width: unset;
    width: 160px;
  }
  #step4-rounded-img {
    display: flex;
    margin-left: 1.3em;
  }
  #pathway1-button1,
  #pathway2-button1,
  #pathway3-button1,
  #pathway3-button2,
  #pathway5-button1 {
    padding: 10px;
  }
  #pathway1-button2,
  #pathway2-button2,
  #pathway4-button1,
  #pathway4-button2,
  #pathway6-button1 {
    padding: 10px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .top-card,
  .bottom-card {
    flex-direction: column;
  }
  #step1,
  #step2,
  #step5,
  #step6 {
    margin: 0px;
  }
  #step1 {
    margin-bottom: 15px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  #step1 {
    margin-right: 10px;
  }
  #step2 {
    margin-left: 10px;
  }
  #step1,
  #step5 {
    margin-bottom: 0px;
  }
  .top-card,
  .bottom-card {
    flex-direction: row;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
}
</style>
